
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("1imNS", function(module, exports) {

$parcel$export(module.exports, "Main", () => $d409264451843df7$export$861edd1ccea2f746);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $dEIJ1 = parcelRequire("dEIJ1");

var $bgZhH = parcelRequire("bgZhH");

var $77Pl9 = parcelRequire("77Pl9");
const $d409264451843df7$var$mainElementStyles = {
    root: "_nd5l1gzg _19121cl4 _qwfh1wug",
    fixedContentArea: "_1reo1wug _18m91wug _152t1l7u _165t1run _13wn1if8"
}; /**
    * Use the Main area for the main page content. It has a fluid width and will expand to fill available space.
    */ 
function $d409264451843df7$export$861edd1ccea2f746({ children: children, isFixed: isFixed, xcss: xcss, skipLinkLabel: skipLinkLabel = 'Main Content', testId: testId, id: providedId }) {
    const id = (0, $bgZhH.useLayoutId)({
        providedId: providedId
    });
    (0, $dEIJ1.useSkipLink)(id, skipLinkLabel);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Fragment), {
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
            id: id,
            "data-layout-slot": true,
            className: (0, $35pXk.default)([
                $d409264451843df7$var$mainElementStyles.root,
                isFixed && $d409264451843df7$var$mainElementStyles.fixedContentArea,
                xcss
            ]),
            role: "main",
            "data-testid": testId,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $77Pl9.MainStickyContext).Provider, {
                value: Boolean(isFixed),
                children: children
            })
        })
    });
}

});
parcelRegister("77Pl9", function(module, exports) {

$parcel$export(module.exports, "MainStickyContext", () => $c966cdfdac2b3cd1$export$3b369e2c6c1ec840);

var $gwFzn = parcelRequire("gwFzn");
const $c966cdfdac2b3cd1$export$3b369e2c6c1ec840 = /*#__PURE__*/ (0, $gwFzn.createContext)(false);

});


parcelRegister("lpfM9", function(module, exports) {

$parcel$export(module.exports, "PanelLoader", () => $d8af34c11b1c225c$export$bec010aa49373196);

var $jmjWc = parcelRequire("jmjWc");

const $d8af34c11b1c225c$export$bec010aa49373196 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "mQOM4",
    name: "PanelLoader",
    loader: async ()=>(await (parcelRequire("7xXpB"))).RightPanel
});

});
parcelRegister("7xXpB", function(module, exports) {

let $57e9b36d422ae5cb$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $57e9b36d422ae5cb$var$load("eI3Gm"),
    $57e9b36d422ae5cb$var$load("ibBUd"),
    $57e9b36d422ae5cb$var$load("9ZTsO"),
    $57e9b36d422ae5cb$var$load("emd3r"),
    $57e9b36d422ae5cb$var$load("gzLQS"),
    $57e9b36d422ae5cb$var$load("7YFVd"),
    $57e9b36d422ae5cb$var$load("6qah4"),
    $57e9b36d422ae5cb$var$load("aZinD"),
    $57e9b36d422ae5cb$var$load("cvXSy")
]).then(()=>parcelRequire('8CeBV'));

});
parcelRegister("lhnSv", function(module, exports) {
"use strict";


let $f7ddb539c5788a9e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("9WHwv")).shardUrl((parcelRequire("fzRTW")).resolve(id), maxShards));
    };
module.exports = $f7ddb539c5788a9e$var$load;

});
parcelRegister("9WHwv", function(module, exports) {

$parcel$export(module.exports, "shardUrl", () => $73db4aabb0664d41$export$2bf9932c19d6a5d2, (v) => $73db4aabb0664d41$export$2bf9932c19d6a5d2 = v);
$parcel$export(module.exports, "domainShardingKey", () => $73db4aabb0664d41$export$f6f4188f9108e61, (v) => $73db4aabb0664d41$export$f6f4188f9108e61 = v);
// TODO: convert this file to ESM once HMR issues are resolved
var $73db4aabb0664d41$export$2bf9932c19d6a5d2;
var $73db4aabb0664d41$export$1d37a31d51d1e3ed;
var $73db4aabb0664d41$export$b4cd98d62f81485f;
var $73db4aabb0664d41$export$108ff8fc702e621f;
var $73db4aabb0664d41$export$f6f4188f9108e61;
"use strict";
let $73db4aabb0664d41$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 *
 * @param {string} pathname
 * @returns {string}
 */ function $73db4aabb0664d41$var$getFilenameFromUrlPath(pathname) {
    let lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 *
 * @param {string} str
 * @param {number} maxShards
 * @returns {number}
 */ function $73db4aabb0664d41$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    let totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        let n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
let $73db4aabb0664d41$var$trailingShardRegex = /-\d+$/;
/**
 * @param {string} subdomain
 */ function $73db4aabb0664d41$var$removeTrailingShard(subdomain) {
    if (!$73db4aabb0664d41$var$trailingShardRegex.test(subdomain)) return subdomain;
    let shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 *
 * @param {string} domain
 * @param {number} shard
 */ function $73db4aabb0664d41$var$applyShardToDomain(domain, shard) {
    let i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    let shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$73db4aabb0664d41$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    let firstSubdomain = $73db4aabb0664d41$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards) {
    let parsedUrl = new URL(url);
    let fileName = $73db4aabb0664d41$var$getFilenameFromUrlPath(parsedUrl.pathname);
    let shardNumber = $73db4aabb0664d41$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $73db4aabb0664d41$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$73db4aabb0664d41$var$globalKeyName]) return url;
    return $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards);
}
$73db4aabb0664d41$export$2bf9932c19d6a5d2 = $73db4aabb0664d41$var$shardUrl;
$73db4aabb0664d41$export$1d37a31d51d1e3ed = $73db4aabb0664d41$var$shardUrlUnchecked;
$73db4aabb0664d41$export$b4cd98d62f81485f = $73db4aabb0664d41$var$getDomainShardIndex;
$73db4aabb0664d41$export$108ff8fc702e621f = $73db4aabb0664d41$var$applyShardToDomain;
$73db4aabb0664d41$export$f6f4188f9108e61 = $73db4aabb0664d41$var$globalKeyName;

});

parcelRegister("fzRTW", function(module, exports) {

$parcel$export(module.exports, "register", () => $b573ef97cec72009$export$6503ec6e8aabbaf, (v) => $b573ef97cec72009$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $b573ef97cec72009$export$f7ad0328861e2f03, (v) => $b573ef97cec72009$export$f7ad0328861e2f03 = v);
var $b573ef97cec72009$export$6503ec6e8aabbaf;
var $b573ef97cec72009$export$f7ad0328861e2f03;
"use strict";
var $b573ef97cec72009$var$mapping = new Map();
function $b573ef97cec72009$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$b573ef97cec72009$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $b573ef97cec72009$var$resolve(id) {
    var resolved = $b573ef97cec72009$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$b573ef97cec72009$export$6503ec6e8aabbaf = $b573ef97cec72009$var$register;
$b573ef97cec72009$export$f7ad0328861e2f03 = $b573ef97cec72009$var$resolve;

});




parcelRegister("i3ftG", function(module, exports) {

$parcel$export(module.exports, "TopBar", () => $f36f34b6e40878ba$export$c4e96258f3b6511);
/* top-bar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $dh538 = parcelRequire("dh538");

var $dEIJ1 = parcelRequire("dEIJ1");

var $4QwsP = parcelRequire("4QwsP");

var $g32Zd = parcelRequire("g32Zd");

var $K0HEo = parcelRequire("K0HEo");

var $8jREP = parcelRequire("8jREP");

var $dGAIk = parcelRequire("dGAIk");

var $bgZhH = parcelRequire("bgZhH");
const $f36f34b6e40878ba$var$styles = {
    root: "_nd5l8cbt _zulpu2gc _18zrutpp _179rzgxb _1e0c11p5 _yv0e1mfv _4cvr1h6o _bfhkvuon _vchhusvi _4t3i2mmk _152t1nws _kqsw1if8 _1pbyegat _d6vu1bgi",
    oldLayoutStyles: "_1rqtc57g",
    newLayoutStyles: "_1j8b18ax"
}; /**
    * The top bar layout area. It will display at the top of the screen, below the banner if one is present.
    */ 
function $f36f34b6e40878ba$export$c4e96258f3b6511({ children: children, xcss: xcss, UNSAFE_height: UNSAFE_height = 48, skipLinkLabel: skipLinkLabel = 'Top Bar', testId: testId, id: providedId, UNSAFE_theme: UNSAFE_theme }) {
    const dangerouslyHoistSlotSizes = (0, $gwFzn.useContext)((0, $8jREP.DangerouslyHoistSlotSizes));
    const id = (0, $bgZhH.useLayoutId)({
        providedId: providedId
    });
    (0, $dEIJ1.useSkipLink)(id, skipLinkLabel);
    const customTheme = (0, $g32Zd.useCustomTheme)(UNSAFE_theme);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4QwsP.HasCustomThemeContext).Provider, {
        value: customTheme.isEnabled,
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)("header", {
            id: id,
            "data-layout-slot": true,
            className: (0, $35pXk.default)([
                $f36f34b6e40878ba$var$styles.root,
                (0, $dh538.fg)('platform_design_system_nav4_top_nav_columns') ? $f36f34b6e40878ba$var$styles.newLayoutStyles : $f36f34b6e40878ba$var$styles.oldLayoutStyles,
                xcss
            ]),
            "data-testid": testId,
            style: customTheme.isEnabled ? customTheme.style : undefined,
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dGAIk.HoistCssVarToLocalGrid), {
                    variableName: (0, $K0HEo.topBarMountedVar),
                    value: UNSAFE_height
                }),
                dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
                // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
                // When they aren't needed anymore we can delete them wholesale.
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dGAIk.DangerouslyHoistCssVarToDocumentRoot), {
                    variableName: (0, $K0HEo.UNSAFE_topBarVar),
                    value: UNSAFE_height
                }) // ------ END UNSAFE STYLES ------
                ,
                children
            ]
        })
    });
}

});
parcelRegister("g32Zd", function(module, exports) {

$parcel$export(module.exports, "useCustomTheme", () => $2bbeb19f52f85437$export$c0c5f5b297b77726);

var $gwFzn = parcelRequire("gwFzn");

var $cVTJv = parcelRequire("cVTJv");
function $2bbeb19f52f85437$export$c0c5f5b297b77726(theme) {
    const value = (0, $gwFzn.useMemo)(()=>{
        if (!theme?.backgroundColor || !theme?.highlightColor) return {
            isEnabled: false
        };
        /**
			 * Re-creating the `theme` object from it's pieces.
			 *
			 * _Technically_ we could just use `theme`, but that would involve an eslint opt out
			 * as we would be leveraging a value (`theme`) not in the dependency array.
			 *
			 * The current approach is the most correct™️ and avoids foot guns.
			 * We are only using values in the effect that are defined in the dependency array 🙌
			 */ const value = {
            backgroundColor: theme.backgroundColor,
            highlightColor: theme.highlightColor
        };
        const style = (0, $cVTJv.getCustomThemeStyles)(value);
        if (!style) // Either the `backgroundColor` or `highlightColor` could not be parsed
        return {
            isEnabled: false
        };
        return {
            isEnabled: true,
            style: style
        };
    }, // Using individual properties as keys for improved memoization.
    // Now this effect will only run if the values change rather than
    // the reference to the object (which might be new on every call)
    [
        theme?.backgroundColor,
        theme?.highlightColor
    ]);
    return value;
}

});
parcelRegister("cVTJv", function(module, exports) {

$parcel$export(module.exports, "getCustomThemeStyles", () => $1f75fe3b8fe3301c$export$3986d75fe2da3239);

var $dZUTc = parcelRequire("dZUTc");

var $lNB6j = parcelRequire("lNB6j");

var $kW0lJ = parcelRequire("kW0lJ");

var $ikMTL = parcelRequire("ikMTL");

var $kuJSQ = parcelRequire("kuJSQ");

var $98yls = parcelRequire("98yls");
function $1f75fe3b8fe3301c$var$toRGBString({ r: r, g: g, b: b }) {
    return `rgb(${r}, ${g}, ${b})`;
}
function $1f75fe3b8fe3301c$var$toRGBAString({ r: r, g: g, b: b, a: a }) {
    return `rgba(${r}, ${g}, ${b}, ${a})`;
}
// Using raw hex codes because custom colors break out of the tokens model
// We will need to invert the colors based on backgroundColor independently of the app's color mode (dark/light)
// Values here are not final
const $1f75fe3b8fe3301c$var$buttonStyles = {
    light: {
        [(0, $lNB6j.themedButtonBackground)]: 'transparent',
        [(0, $lNB6j.themedButtonBackgroundHovered)]: (0, $kuJSQ.palette).Neutral200A,
        [(0, $lNB6j.themedButtonBackgroundPressed)]: (0, $kuJSQ.palette).Neutral300A,
        [(0, $lNB6j.themedButtonBorder)]: (0, $kuJSQ.palette).Neutral300A,
        [(0, $lNB6j.themedButtonSelectedBackground)]: (0, $kuJSQ.palette).Neutral300A,
        [(0, $lNB6j.themedButtonSelectedBackgroundHovered)]: (0, $kuJSQ.palette).Neutral400A,
        [(0, $lNB6j.themedButtonSelectedBackgroundPressed)]: (0, $kuJSQ.palette).Neutral500A,
        [(0, $lNB6j.themedButtonDisabledText)]: (0, $kuJSQ.palette).Neutral400A,
        [(0, $lNB6j.themedButtonDisabledBackground)]: (0, $kuJSQ.palette).Neutral100A
    },
    dark: {
        [(0, $lNB6j.themedButtonBackground)]: 'transparent',
        [(0, $lNB6j.themedButtonBackgroundHovered)]: (0, $kuJSQ.palette).DarkNeutral200A,
        [(0, $lNB6j.themedButtonBackgroundPressed)]: (0, $kuJSQ.palette).DarkNeutral300A,
        [(0, $lNB6j.themedButtonBorder)]: (0, $kuJSQ.palette).DarkNeutral300A,
        [(0, $lNB6j.themedButtonSelectedBackground)]: (0, $kuJSQ.palette).DarkNeutral300A,
        [(0, $lNB6j.themedButtonSelectedBackgroundHovered)]: (0, $kuJSQ.palette).DarkNeutral400A,
        [(0, $lNB6j.themedButtonSelectedBackgroundPressed)]: (0, $kuJSQ.palette).DarkNeutral500A,
        [(0, $lNB6j.themedButtonDisabledText)]: (0, $kuJSQ.palette).DarkNeutral400A,
        [(0, $lNB6j.themedButtonDisabledBackground)]: (0, $kuJSQ.palette).DarkNeutral100A
    }
};
const $1f75fe3b8fe3301c$var$logoStyles = {
    light: {
        [(0, $dZUTc.themedLogoIcon)]: (0, $kuJSQ.palette).DarkNeutral0,
        [(0, $dZUTc.themedLogoText)]: (0, $kuJSQ.palette).DarkNeutral0
    },
    dark: {
        [(0, $dZUTc.themedLogoIcon)]: (0, $kuJSQ.palette).Neutral0,
        [(0, $dZUTc.themedLogoText)]: (0, $kuJSQ.palette).Neutral0
    }
};
function $1f75fe3b8fe3301c$export$3986d75fe2da3239({ backgroundColor: backgroundColor, highlightColor: highlightColor }) {
    const backgroundRgb = typeof backgroundColor === 'string' ? (0, $ikMTL.parseHex)(backgroundColor) : backgroundColor;
    const highlightRgb = typeof highlightColor === 'string' ? (0, $ikMTL.parseHex)(highlightColor) : highlightColor;
    if (!backgroundRgb || !highlightRgb) return null;
    const textColor = (0, $kW0lJ.getTextColor)(backgroundRgb);
    const colorMode = (0, $kW0lJ.getColorMode)(backgroundRgb);
    const highlightTextColor = (0, $kW0lJ.getTextColor)(highlightRgb);
    return {
        backgroundColor: $1f75fe3b8fe3301c$var$toRGBString(backgroundRgb),
        color: textColor.hex,
        ...$1f75fe3b8fe3301c$var$buttonStyles[colorMode],
        ...$1f75fe3b8fe3301c$var$logoStyles[colorMode],
        ...$1f75fe3b8fe3301c$var$getSelectedStyles({
            backgroundColor: backgroundRgb,
            colorMode: colorMode
        }),
        /**
		 * Search colors are the same as Nav 3
		 */ [(0, $98yls.themedSearchBorder)]: $1f75fe3b8fe3301c$var$toRGBAString({
            ...textColor.rgb,
            a: 0.5
        }),
        [(0, $98yls.themedSearchBorderFocused)]: $1f75fe3b8fe3301c$var$toRGBAString({
            ...highlightRgb,
            a: 0.8
        }),
        /**
		 * Primary button colors are the same as Nav 3,
		 * except the text color which can sometimes differ because we're
		 * now following WCAG
		 */ [(0, $lNB6j.themedButtonPrimaryBackground)]: $1f75fe3b8fe3301c$var$toRGBString(highlightRgb),
        [(0, $lNB6j.themedButtonPrimaryBackgroundHovered)]: $1f75fe3b8fe3301c$var$toRGBAString({
            ...highlightRgb,
            a: 0.8
        }),
        [(0, $lNB6j.themedButtonPrimaryBackgroundPressed)]: $1f75fe3b8fe3301c$var$toRGBAString({
            ...highlightRgb,
            a: 0.65
        }),
        [(0, $lNB6j.themedButtonPrimaryText)]: highlightTextColor.hex
    };
}
/**
 * Precomputed RGBA values for the selected backgrounds
 */ const $1f75fe3b8fe3301c$var$selectedBackgroundRGBA = {
    light: (0, $kuJSQ.paletteRgba).Neutral300A,
    dark: (0, $kuJSQ.paletteRgba).DarkNeutral300A
};
function $1f75fe3b8fe3301c$var$getSelectedStyles({ backgroundColor: backgroundColor, colorMode: colorMode }) {
    /**
	 * The background color of the selected button in its default state.
	 *
	 * We are referring to this as a foreground color because it is semi-transparent,
	 * so is not the actual color displayed when the button is on top of a background color.
	 */ const foregroundColor = $1f75fe3b8fe3301c$var$selectedBackgroundRGBA[colorMode];
    /**
	 * The blended color seen when the selected background is over the top bar.
	 */ const blendedBackground = (0, $kW0lJ.simpleAlphaComposite)({
        background: backgroundColor,
        foreground: foregroundColor
    });
    return {
        [(0, $lNB6j.themedButtonSelectedText)]: (0, $kW0lJ.getTextColor)(blendedBackground).hex,
        // Border colors are chosen to match the text, while remaining in the palette
        [(0, $lNB6j.themedButtonSelectedBorder)]: (0, $kW0lJ.isLight)(blendedBackground) ? (0, $kuJSQ.palette).Neutral1100 : (0, $kuJSQ.palette).DarkNeutral1100
    };
}

});
parcelRegister("kW0lJ", function(module, exports) {

$parcel$export(module.exports, "isLight", () => $83a4efb6c4a68b6d$export$44af652f4cca9039);
$parcel$export(module.exports, "getColorMode", () => $83a4efb6c4a68b6d$export$5573a5bab3e074b5);
$parcel$export(module.exports, "getTextColor", () => $83a4efb6c4a68b6d$export$5357fe757c335c0d);
$parcel$export(module.exports, "simpleAlphaComposite", () => $83a4efb6c4a68b6d$export$e5e64c30bee1469b);
/**
 * Removes sRGB gamma correction from the provided channel.
 * The resulting linear channel directly corresponds to subpixel intensity.
 *
 * Expects a normalized sRGB value (between 0 and 1)
 *
 * This formula is derived from WCAG2 guidelines:
 * https://www.w3.org/WAI/WCAG22/Techniques/general/G18.html#tests
 */ function $83a4efb6c4a68b6d$var$linearizeRGBChannel(channel) {
    return channel <= 0.04045 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
}
/**
 * This formula is derived from WCAG2 guidelines:
 * https://www.w3.org/WAI/WCAG22/Techniques/general/G18.html#tests
 */ function $83a4efb6c4a68b6d$var$relativeLuminanceW3C({ r: r, g: g, b: b }) {
    /**
	 * Normalized sRGB - each channel is between 0 and 1
	 */ const normal = {
        r: r / 255,
        g: g / 255,
        b: b / 255
    };
    /**
	 * linear RGB - the gamma correction of sRGB is removed and
	 * the channels correspond directly to subpixel intensity
	 */ const linear = {
        r: $83a4efb6c4a68b6d$var$linearizeRGBChannel(normal.r),
        g: $83a4efb6c4a68b6d$var$linearizeRGBChannel(normal.g),
        b: $83a4efb6c4a68b6d$var$linearizeRGBChannel(normal.b)
    };
    // For linear RGB, the relative luminance of a color is defined as:
    const L = 0.2126 * linear.r + 0.7152 * linear.g + 0.0722 * linear.b;
    return L;
}
/**
 * This is the intersection point for W3C contrast ratio against:
 *
 * 1. black
 * 2. white
 *
 * In other words, the background luminance for which W3C contrast is equal
 * for both white and black text.
 *
 * Using a precomputed flip point means we can save a lot of calculations.
 *
 * This is only the theoretical flip point, and we can adjust it as needed.
 */ const $83a4efb6c4a68b6d$var$flipLuminance = 0.179129;
function $83a4efb6c4a68b6d$export$44af652f4cca9039(color) {
    return $83a4efb6c4a68b6d$var$relativeLuminanceW3C(color) >= $83a4efb6c4a68b6d$var$flipLuminance;
}
function $83a4efb6c4a68b6d$export$5573a5bab3e074b5(backgroundColor) {
    if ($83a4efb6c4a68b6d$var$relativeLuminanceW3C(backgroundColor) >= $83a4efb6c4a68b6d$var$flipLuminance) return 'light';
    return 'dark';
}
const $83a4efb6c4a68b6d$var$textColor = {
    light: {
        hex: '#000',
        rgb: {
            r: 0,
            g: 0,
            b: 0
        }
    },
    dark: {
        hex: '#FFF',
        rgb: {
            r: 255,
            g: 255,
            b: 255
        }
    }
};
function $83a4efb6c4a68b6d$export$5357fe757c335c0d(backgroundColor) {
    const colorMode = $83a4efb6c4a68b6d$export$5573a5bab3e074b5(backgroundColor);
    return $83a4efb6c4a68b6d$var$textColor[colorMode];
}
function $83a4efb6c4a68b6d$export$e5e64c30bee1469b({ background: background, foreground: foreground }) {
    return {
        r: foreground.a * foreground.r + background.r * (1 - foreground.a),
        g: foreground.a * foreground.g + background.g * (1 - foreground.a),
        b: foreground.a * foreground.b + background.b * (1 - foreground.a)
    };
}

});

parcelRegister("ikMTL", function(module, exports) {

$parcel$export(module.exports, "parseHex", () => $7c67c8e63aba96ed$export$103711ef09c6edec);
// valid hex color (optional alpha channel) - 3, 4, 6, or 8 digits after the #
const $7c67c8e63aba96ed$var$isValidHex = (hex)=>// Not using `([a-f0-9]{3,4}){1,2}` because that allows 7 digits which is invalid
    /^#(([a-f0-9]{3,4})|([a-f0-9][a-f0-9]){3,4})$/i.test(hex);
function $7c67c8e63aba96ed$export$103711ef09c6edec(color) {
    if (!$7c67c8e63aba96ed$var$isValidHex(color)) return null;
    let channels;
    if (color.length <= 5) // Hex code is shorthand - RGB channels are one digit
    channels = {
        r: color[1].repeat(2),
        g: color[2].repeat(2),
        b: color[3].repeat(2)
    };
    else // Hex code is longhand - RGB channels are two digits
    channels = {
        r: color.slice(1, 3),
        g: color.slice(3, 5),
        b: color.slice(5, 7)
    };
    return {
        r: parseInt(channels.r, 16),
        g: parseInt(channels.g, 16),
        b: parseInt(channels.b, 16)
    };
}

});

parcelRegister("kuJSQ", function(module, exports) {

$parcel$export(module.exports, "palette", () => $8a083d3bf18dbecb$export$eaad8caa32d2521d);
$parcel$export(module.exports, "paletteRgba", () => $8a083d3bf18dbecb$export$c9b84419dae66a82);
/**
 * Copied from the brand refresh palette.
 *
 * Ideally we'd codegen this but the brand refresh palette isn't exposed
 * through public API and we shouldn't use the private API of another package.
 */ const $8a083d3bf18dbecb$export$eaad8caa32d2521d = {
    'DarkNeutral-100': '#111213',
    'DarkNeutral-100A': '#01040475',
    DarkNeutral0: '#18191A',
    DarkNeutral100: '#1F1F21',
    DarkNeutral100A: '#BDBDBD0A',
    DarkNeutral200: '#242528',
    DarkNeutral200A: '#CECED912',
    DarkNeutral250: '#2B2C2F',
    DarkNeutral250A: '#D9DAE71A',
    DarkNeutral300: '#303134',
    DarkNeutral300A: '#E3E4F21F',
    DarkNeutral350: '#3D3F43',
    DarkNeutral350A: '#E8EDFD2E',
    DarkNeutral400: '#4B4D51',
    DarkNeutral400A: '#E5E9F640',
    DarkNeutral500: '#63666B',
    DarkNeutral500A: '#E9F0FB5C',
    DarkNeutral600: '#7E8188',
    DarkNeutral700: '#96999E',
    DarkNeutral800: '#A9ABAF',
    DarkNeutral900: '#BFC1C4',
    DarkNeutral1000: '#CECFD2',
    DarkNeutral1100: '#E2E3E4',
    Neutral0: '#FFFFFF',
    Neutral100: '#F8F8F8',
    Neutral100A: '#17171708',
    Neutral200: '#F0F1F2',
    Neutral200A: '#0515240F',
    Neutral300: '#DDDEE1',
    Neutral300A: '#0B120E24',
    Neutral400: '#B7B9BE',
    Neutral400A: '#080F214A',
    Neutral500: '#8C8F97',
    Neutral500A: '#050C1F75',
    Neutral600: '#7D818A',
    Neutral700: '#6B6E76',
    Neutral800: '#505258',
    Neutral900: '#3B3D42',
    Neutral1000: '#292A2E',
    Neutral1100: '#1E1F21'
};
const $8a083d3bf18dbecb$export$c9b84419dae66a82 = {
    DarkNeutral300A: {
        r: 0xe3,
        g: 0xe4,
        b: 0xf2,
        a: 0x1f / 255
    },
    Neutral300A: {
        r: 0x0b,
        g: 0x12,
        b: 0x0e,
        a: 0x24 / 255
    }
};

});

parcelRegister("98yls", function(module, exports) {

$parcel$export(module.exports, "themedSearchBorder", () => $4db0b5a5ba1ce7a0$export$ae6fbf5ba3a7a784);
$parcel$export(module.exports, "themedSearchBorderFocused", () => $4db0b5a5ba1ce7a0$export$ee42b8430f4c19bd);
$parcel$export(module.exports, "useLegacySearchTheme", () => $4db0b5a5ba1ce7a0$export$18a29b1ed2212823);

var $lNB6j = parcelRequire("lNB6j");

var $4QwsP = parcelRequire("4QwsP");
const $4db0b5a5ba1ce7a0$export$ae6fbf5ba3a7a784 = '--ds-top-bar-search-border';
const $4db0b5a5ba1ce7a0$export$ee42b8430f4c19bd = '--ds-top-bar-search-border-focused';
/**
 * Theme object intended for use with Search Platform components while transitioning to nav4.
 *
 * This is for backwards compatibility with the legacy theming API that was designed for nav3.
 *
 * As nav4 matures we will ideally evolve the theming solution inside Search Platform,
 * at which point this legacy theme object will not be needed.
 */ const $4db0b5a5ba1ce7a0$var$legacySearchTheme = {
    default: {
        backgroundColor: 'transparent',
        color: 'currentColor',
        borderColor: `var(${$4db0b5a5ba1ce7a0$export$ae6fbf5ba3a7a784})`
    },
    focus: {
        /**
     * When expanded the input ignores the custom theme,
     * except for its border which is derived from the highlight color.
     */ color: "var(--ds-text, #172B4D)",
        backgroundColor: "var(--ds-background-input-pressed, #FFFFFF)",
        borderColor: `var(${$4db0b5a5ba1ce7a0$export$ee42b8430f4c19bd})`,
        boxShadow: `inset 0px 0px 0px 1px var(${$4db0b5a5ba1ce7a0$export$ee42b8430f4c19bd})`
    },
    hover: {
        /**
     * This is not actually used for the search bar input (at least by the Search Platform components).
     *
     * Instead it's used as the hover background color for a close button when on mobile.
     */ backgroundColor: `var(${(0, $lNB6j.themedButtonBackgroundHovered)})`
    }
};
function $4db0b5a5ba1ce7a0$export$18a29b1ed2212823() {
    const hasCustomTheme = (0, $4QwsP.useHasCustomTheme)();
    if (hasCustomTheme) return $4db0b5a5ba1ce7a0$var$legacySearchTheme;
    return undefined;
}

});




parcelRegister("eBBZq", function(module, exports) {

$parcel$export(module.exports, "AppSwitcherButton", () => $4ea98e6e25820b6e$export$66169bdb3eb9897d);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $lGgRw = parcelRequire("lGgRw");

var $inPa6 = parcelRequire("inPa6");

var $4kfV4 = parcelRequire("4kfV4");

var $eOSTl = parcelRequire("eOSTl");

var $dPJCf = parcelRequire("dPJCf");

var $dEBDF = parcelRequire("dEBDF");

var $tgnKt = parcelRequire("tgnKt");
const $4ea98e6e25820b6e$export$66169bdb3eb9897d = ()=>{
    const intl = (0, $dBxQj.default)();
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [isOpen, setIsOpen] = (0, $gwFzn.useState)(false);
    const onClick = ()=>{
        setIsOpen(!isOpen);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'globalNavigation',
                action: 'clicked',
                actionSubject: 'navigationItem',
                actionSubjectId: 'atlassianSwitcher',
                attributes: {
                    selectedItemPageContext: routeDataRef.current?.routeName,
                    navigationLayer: 'global',
                    navigationContainer: 'top',
                    navVersion: '4',
                    navdexPointType: (0, $dEBDF.START_TOUCH)
                }
            }
        }).fire();
    };
    const onClose = ()=>{
        setIsOpen(false);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lGgRw.default), {
        isOpen: isOpen,
        onClose: onClose,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $tgnKt.AppSwitcherContent), null),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", triggerProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eOSTl.AppSwitcher), {
                label: intl.formatMessage($4ea98e6e25820b6e$var$i18n.switcher),
                isSelected: isOpen,
                onClick: onClick
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4kfV4.default), {
                isTinted: false,
                shouldAllowClickThrough: !isOpen,
                onBlanketClicked: onClose
            })),
        placement: "bottom-start",
        rootBoundary: "document"
    });
};
const $4ea98e6e25820b6e$var$i18n = (0, $2nPZH.defineMessages)({
    switcher: {
        id: "app-navigation.top-navigation.app-switcher",
        defaultMessage: "Switch sites or apps"
    }
});

});
parcelRegister("tgnKt", function(module, exports) {

$parcel$export(module.exports, "AppSwitcherContent", () => $a17e741d85380f31$export$635f95e4f8a4fd7c);

var $gwFzn = parcelRequire("gwFzn");

var $cm2rU = parcelRequire("cm2rU");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $emHKt = parcelRequire("emHKt");
var $2uNd6 = parcelRequire("2uNd6");
var $hNJxa = parcelRequire("hNJxa");

var $9QvUi = parcelRequire("9QvUi");

var $9wGTI = parcelRequire("9wGTI");

var $bQm3c = parcelRequire("bQm3c");

var $7aRa9 = parcelRequire("7aRa9");

var $1Y265 = parcelRequire("1Y265");
const $a17e741d85380f31$var$maxHeightWrapper = (0, $ecnYn.xcss)({
    maxHeight: 'calc(100vh - 100px)'
});
const $a17e741d85380f31$var$joinableProductsInSwitcherProvider = (0, $emHKt.createJoinableSitesProvider)((0, $hNJxa.fetchProductRecommendationsWithCollaborators)('/gateway/api/invitations'));
const $a17e741d85380f31$export$635f95e4f8a4fd7c = (0, $7aRa9.withFlags)(({ flags: flags })=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const customShowFlagMemo = (0, $gwFzn.useMemo)(()=>(0, $1Y265.customShowFlag)(flags), [
        flags
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $a17e741d85380f31$var$maxHeightWrapper
    }, (0, $9wGTI.fg)('joinable_products_in_switcher_gate') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2uNd6.AtlassianSwitcherLoader), {
        product: "confluence",
        cloudId: cloudId,
        joinableSitesDataProvider: $a17e741d85380f31$var$joinableProductsInSwitcherProvider,
        showFlag: customShowFlagMemo,
        discoverySection: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9QvUi.default), {
            placementId: "app-switcher-discovery-section",
            // @ts-ignore - Type 'ComponentType<Partial<ErrorBoundaryPropsWithRender>> is not assignable to type 'PlacementComponent<LocalPlacementProps>'
            PlacementComponent: (0, $cm2rU.default)
        })
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2uNd6.AtlassianSwitcherLoader), {
        product: "confluence",
        cloudId: cloudId,
        discoverySection: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9QvUi.default), {
            placementId: "app-switcher-discovery-section",
            // @ts-ignore - Type 'ComponentType<Partial<ErrorBoundaryPropsWithRender>> is not assignable to type 'PlacementComponent<LocalPlacementProps>'
            PlacementComponent: (0, $cm2rU.default)
        })
    }));
});

});


parcelRegister("9MAeh", function(module, exports) {

$parcel$export(module.exports, "NotificationsButton", () => $a25a74f29b49c48c$export$40e326b1271b1326);

var $gwFzn = parcelRequire("gwFzn");

var $j1Ss3 = parcelRequire("j1Ss3");

var $4y1GY = parcelRequire("4y1GY");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $lnHWt = parcelRequire("lnHWt");

var $d2LG0 = parcelRequire("d2LG0");

var $inPa6 = parcelRequire("inPa6");

var $lGgRw = parcelRequire("lGgRw");

var $9Zu7R = parcelRequire("9Zu7R");

var $c3uZU = parcelRequire("c3uZU");

var $eBhbk = parcelRequire("eBhbk");

var $gKr8t = parcelRequire("gKr8t");

var $ljm2R = parcelRequire("ljm2R");

var $d9tcB = parcelRequire("d9tcB");
var $bQm3c = parcelRequire("bQm3c");

var $dPJCf = parcelRequire("dPJCf");

var $jmjWc = parcelRequire("jmjWc");

var $epLE5 = parcelRequire("epLE5");

var $9wGTI = parcelRequire("9wGTI");

var $efvKr = parcelRequire("efvKr");

var $de2j9 = parcelRequire("de2j9");
const $a25a74f29b49c48c$var$fabricNotificationLogUrl = '/gateway/api/notification-log';
const $a25a74f29b49c48c$var$REFRESH_INTERVAL = 60000;
const $a25a74f29b49c48c$var$CLEAR_BADGE_TIME = 10000;
const $a25a74f29b49c48c$var$MAX_NOTIFICATION_COUNT = 9;

const $a25a74f29b49c48c$export$bae4076b81272f49 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "MEiTH",
    name: "NotificationsContentLoader",
    loader: async ()=>(await (parcelRequire("6jxCT"))).NotificationsContent
});

const $a25a74f29b49c48c$var$useLazyClickAnalytics = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("80zTh"))).fireNotificationsClickedAnalytics);
class $a25a74f29b49c48c$var$EmptyNotificationLogClient extends (0, $c3uZU.NotificationLogClient) {
    countUnseenNotifications() {
        return Promise.resolve({
            count: 0
        });
    }
    constructor(){
        super('', '');
    }
}
const $a25a74f29b49c48c$var$useNotificationLogClient = ()=>{
    return (0, $gwFzn.useMemo)(()=>new (0, $c3uZU.NotificationLogClient)($a25a74f29b49c48c$var$fabricNotificationLogUrl, undefined), []);
};
const $a25a74f29b49c48c$export$40e326b1271b1326 = ({ user: user })=>{
    const notificationsButtonRef = (0, $gwFzn.useRef)(null);
    const [isOpen, setIsOpen] = (0, $gwFzn.useState)(false);
    const [isCleared, setIsCleared] = (0, $gwFzn.useState)(false);
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const shouldShowButton = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const intl = (0, $dBxQj.default)();
    const notificationLogClient = $a25a74f29b49c48c$var$useNotificationLogClient();
    const [{ isEditMode: isLiveEditMode }] = (0, $efvKr.useLivePageMode)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const location = (0, $4y1GY.useLocation)();
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const { data: data } = (0, $j1Ss3.useQuery)((0, $d2LG0.default)`query NotificationsButtonQuery{notifications{unseenNotificationCount}}`, {
        client: (0, $gKr8t.getAGGClient)(),
        skip: !userId || !(0, $9wGTI.fg)('confluence_frontend_preload_notifications') //uneeded for anon
    });
    const [unreadCount, setUnreadCount] = (0, $gwFzn.useState)(data?.notifications?.unseenNotificationCount && (0, $9wGTI.fg)('confluence_frontend_preload_notifications') || 0);
    const fireClickedAnalytics = $a25a74f29b49c48c$var$useLazyClickAnalytics(createAnalyticsEvent, routeDataRef.current?.routeName);
    (0, $gwFzn.useEffect)(()=>{
        if (isCleared) {
            const timeout = setTimeout(()=>{
                setIsCleared(false);
            }, $a25a74f29b49c48c$var$CLEAR_BADGE_TIME);
            return ()=>{
                clearTimeout(timeout);
            };
        }
    }, [
        isCleared
    ]);
    const onClick = ()=>{
        if (isOpen) onClose();
        else {
            performance.mark('notification.list.render.start');
            setIsCleared(true);
            setIsOpen(true);
        }
        fireClickedAnalytics();
    };
    const onClose = (0, $gwFzn.useCallback)(()=>{
        notificationsButtonRef.current?.focus();
        setIsOpen(false);
        performance.clearMarks('notification.list.render.start');
    }, []);
    (0, $gwFzn.useEffect)(()=>{
        if (isOpen && location && (0, $9wGTI.fg)('confluence-frontend-close-belldrawer-on-transition')) // on any transition close open notification drawer. On initial Load transitionId = 0
        onClose();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onClose,
        location
    ]);
    (0, $gwFzn.useEffect)(()=>{
        notificationLogClient.countUnseenNotifications().then((res)=>{
            setUnreadCount(res.count);
            if (res.count >= 9) createAnalyticsEvent({
                type: 'sendScreenEvent',
                data: {
                    name: 'unseenNotificationsOver9'
                }
            }).fire();
        }).catch(()=>{});
    }, [
        createAnalyticsEvent,
        notificationLogClient
    ]);
    const NotificationsBadge = (0, $gwFzn.useMemo)(()=>()=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9Zu7R.NotificationIndicator), {
                onCountUpdated: (count)=>{
                    setUnreadCount(count.newCount);
                },
                notificationLogProvider: Promise.resolve(isCleared || isOpen ? new $a25a74f29b49c48c$var$EmptyNotificationLogClient() : notificationLogClient),
                refreshRate: $a25a74f29b49c48c$var$REFRESH_INTERVAL,
                ssrInitialValue: (0, $9wGTI.fg)('confluence_frontend_preload_notifications') ? data?.notifications?.unseenNotificationCount : undefined
            });
        }, [
        isOpen,
        isCleared,
        notificationLogClient,
        data?.notifications?.unseenNotificationCount
    ]);
    const notificationsLabel = unreadCount <= $a25a74f29b49c48c$var$MAX_NOTIFICATION_COUNT ? intl.formatMessage($a25a74f29b49c48c$var$i18n.notifications, {
        count: unreadCount
    }) : intl.formatMessage($a25a74f29b49c48c$var$i18n.overNineNotifications);
    return !shouldShowButton ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lGgRw.default), {
        placement: "bottom-end",
        shouldFlip: true,
        rootBoundary: "viewport",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($a25a74f29b49c48c$export$bae4076b81272f49, {
                user: user
            }),
        isOpen: isOpen,
        onClose: onClose,
        shouldRenderToParent: true,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eBhbk.Notifications), {
                ...triggerProps,
                badge: NotificationsBadge,
                onClick: onClick,
                isSelected: isOpen,
                label: isLiveEditMode || isOnEditRoute ? notificationsLabel : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ljm2R.ShortcutVisualizer), {
                    shortcut: (0, $ljm2R.UNIVERSAL_NOTIFICATIONS_SHORTCUT),
                    contentBefore: notificationsLabel
                }),
                ref: (0, $lnHWt.mergeRefs)([
                    triggerProps.ref,
                    notificationsButtonRef
                ])
            })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ljm2R.GeneralShortcutListener), {
        deprecatedAccelerator: !(isLiveEditMode || isOnEditRoute) ? (0, $ljm2R.NOTIFICATIONS_SHORTCUT) : undefined,
        accelerator: (0, $ljm2R.UNIVERSAL_NOTIFICATIONS_SHORTCUT),
        listener: onClick,
        isAppNavigationShortcut: true
    }));
};
const $a25a74f29b49c48c$var$i18n = (0, $2nPZH.defineMessages)({
    notifications: {
        id: "app-navigation.top-navigation.notifications",
        defaultMessage: "{count, plural, =0{ Notifications} one{{count, number} Notification} other{{count, number} Notifications}}"
    },
    overNineNotifications: {
        id: "app-navigation.top-navigation.notifications.over-nine-notifications",
        defaultMessage: "Over 9 Notifications"
    }
});

});
parcelRegister("6jxCT", function(module, exports) {

let $498e99e41d903067$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $498e99e41d903067$var$load("gzLQS"),
    $498e99e41d903067$var$load("lCT7Q"),
    $498e99e41d903067$var$load("lggas"),
    $498e99e41d903067$var$load("ej4rO"),
    $498e99e41d903067$var$load("c4YL4"),
    $498e99e41d903067$var$load("lou39"),
    $498e99e41d903067$var$load("aYGIV"),
    $498e99e41d903067$var$load("95BpF"),
    $498e99e41d903067$var$load("56uR7"),
    $498e99e41d903067$var$load("5j5Dl")
]).then(()=>parcelRequire('h4ISV'));

});

parcelRegister("80zTh", function(module, exports) {

let $5d4a29f10a315bcd$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $5d4a29f10a315bcd$var$load("2b5QF").then(()=>parcelRequire('1FDBc'));

});


parcelRegister("cv4vy", function(module, exports) {

$parcel$export(module.exports, "AccountMenuNav3", () => $a5cc9a5330823789$export$4ff56e5cf713dc64);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $cKmJs = parcelRequire("cKmJs");

var $f8qSe = parcelRequire("f8qSe");

var $4mshv = parcelRequire("4mshv");
const $a5cc9a5330823789$export$4ff56e5cf713dc64 = (props)=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4mshv.AccountMenu), {
        ...props,
        AccountMenuLoggedOutState: (0, $cKmJs.AccountMenuLoggedOutStateNav3),
        AccountMenuTrigger: (0, $f8qSe.AccountMenuTriggerNav3)
    });
};

});
parcelRegister("cKmJs", function(module, exports) {

$parcel$export(module.exports, "AccountMenuLoggedOutStateNav3", () => $739c14dbd5941201$export$5e6158d2118ae4aa);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $kLRO8 = parcelRequire("kLRO8");

var $ilSNM = parcelRequire("ilSNM");

var $iRXVy = parcelRequire("iRXVy");

var $hoiF1 = parcelRequire("hoiF1");

var $lSGOy = parcelRequire("lSGOy");
const $739c14dbd5941201$export$5e6158d2118ae4aa = ({ testId: testId, logInLink: logInLink })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $kLRO8.Profile), {
        testId: testId,
        href: logInLink,
        onClick: (event, analytics)=>{
            analytics.update({
                actionSubjectId: 'logInLink'
            }).fire((0, $hoiF1.NAVIGATION_CHANNEL));
        },
        tooltip: (0, $lSGOy.logInTooltip),
        icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ilSNM))), {
            color: "currentColor",
            label: "",
            LEGACY_size: "medium",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($iRXVy)))
        })
    });

});
parcelRegister("hoiF1", function(module, exports) {

$parcel$export(module.exports, "NAVIGATION_CHANNEL", () => $07093422fbc04e7e$export$515664faa1398f37);
$parcel$export(module.exports, "ANALYTICS_CONTEXT", () => $07093422fbc04e7e$export$3cbe56a0cabcff38);
const $07093422fbc04e7e$export$515664faa1398f37 = 'navigation';
const $07093422fbc04e7e$export$3cbe56a0cabcff38 = {
    source: 'atlassianAccountMenu',
    componentName: 'atlassianAccountMenu',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};

});

parcelRegister("lSGOy", function(module, exports) {

$parcel$export(module.exports, "logInTooltip", () => $b51480b69b500518$export$b495e6c63a3a03c1);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");
const $b51480b69b500518$export$b495e6c63a3a03c1 = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
    id: "identity.account-menu.account-menu-logged-out-state.log-in",
    defaultMessage: "Log in"
});

});


parcelRegister("f8qSe", function(module, exports) {

$parcel$export(module.exports, "AccountMenuTriggerNav3", () => $84a2e3c47e22a026$export$89d857133932d6aa);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $dBxQj = parcelRequire("dBxQj");

var $kLRO8 = parcelRequire("kLRO8");

var $5cJSs = parcelRequire("5cJSs");

var $asAwU = parcelRequire("asAwU");

var $lGKVd = parcelRequire("lGKVd");
const $84a2e3c47e22a026$var$imgStyles = (0, $3jLHL.css)({
    borderRadius: '50%',
    width: "var(--ds-space-300, 24px)",
    height: "var(--ds-space-300, 24px)"
});
const $84a2e3c47e22a026$export$89d857133932d6aa = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).forwardRef(({ picture: picture, email: email, trustPicture: trustPicture = false, ...props }, ref)=>{
    const intl = (0, $dBxQj.default)();
    const state = (0, $asAwU.useImageState)(picture || '');
    const tooltip = intl.formatMessage((0, $lGKVd.messages).triggerTooltip);
    return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $kLRO8.Profile), {
        ...props,
        ref: ref,
        tooltip: email || tooltip,
        icon: picture && (trustPicture || state === 'loaded') ? /*#__PURE__*/ (0, $3jLHL.jsx)("img", {
            css: $84a2e3c47e22a026$var$imgStyles,
            src: picture,
            alt: tooltip
        }) : /*#__PURE__*/ (0, $3jLHL.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5cJSs))), {
            color: "currentColor",
            label: tooltip,
            LEGACY_size: "medium",
            spacing: "spacious"
        })
    });
});

});
parcelRegister("5cJSs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::87e7af881897ed302561350d986556a5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3ca1a908cb68508a$var$_react = $3ca1a908cb68508a$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $3ca1a908cb68508a$var$_personAvatar = $3ca1a908cb68508a$var$_interopRequireDefault((parcelRequire("4wwVl")));

var $3ca1a908cb68508a$var$_userAvatarCircle = $3ca1a908cb68508a$var$_interopRequireDefault((parcelRequire("im18V")));
function $3ca1a908cb68508a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PersonAvatarIcon.
 * This component is PersonAvatarIcon, with `UNSAFE_fallbackIcon` set to "UserAvatarCircleIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for user avatar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3ca1a908cb68508a$var$PersonAvatarIcon = (props)=>/*#__PURE__*/ $3ca1a908cb68508a$var$_react.default.createElement($3ca1a908cb68508a$var$_personAvatar.default, Object.assign({
        LEGACY_fallbackIcon: $3ca1a908cb68508a$var$_userAvatarCircle.default
    }, props));
$3ca1a908cb68508a$var$PersonAvatarIcon.Name = 'PersonAvatarIconMigration';
var $3ca1a908cb68508a$var$_default = module.exports.default = $3ca1a908cb68508a$var$PersonAvatarIcon;

});

parcelRegister("asAwU", function(module, exports) {

$parcel$export(module.exports, "useImageState", () => $581d0d4774eb5112$export$2c1df3428fc3264c);

var $gwFzn = parcelRequire("gwFzn");
const $581d0d4774eb5112$export$2c1df3428fc3264c = (src)=>{
    const [state, setState] = (0, $gwFzn.useState)('pending');
    const imgRef = (0, $gwFzn.useRef)();
    (0, $gwFzn.useEffect)(()=>{
        if (!imgRef.current) {
            imgRef.current = new Image();
            imgRef.current.onload = ()=>setState('loaded');
            imgRef.current.onerror = ()=>setState('error');
        }
        setState('pending');
        imgRef.current.src = src;
    }, [
        src
    ]);
    return state;
};

});

parcelRegister("lGKVd", function(module, exports) {

$parcel$export(module.exports, "messages", () => $35d50c55158ea6c2$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $35d50c55158ea6c2$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    triggerTooltip: {
        id: "identity.account-menu.account-menu-popup.skeleton.tooltip",
        defaultMessage: "Account"
    }
});

});


parcelRegister("4mshv", function(module, exports) {

$parcel$export(module.exports, "AccountMenu", () => $1593f61e84401b5f$export$ff20d75d5eda4388);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $ffCOo = parcelRequire("ffCOo");

var $hoiF1 = parcelRequire("hoiF1");

var $8rsbZ = parcelRequire("8rsbZ");

var $axaJh = parcelRequire("axaJh");

var $lUIjo = parcelRequire("lUIjo");
const $1593f61e84401b5f$export$ff20d75d5eda4388 = ({ testId: testId, name: name, picture: picture, email: email, managedBy: managedBy, manageProfileLink: manageProfileLink, viewProfileLink: viewProfileLink, onViewProfileClick: onViewProfileClick, switchAccountLink: switchAccountLink, logOutLink: logOutLink, logInLink: logInLink, onThemeChange: onThemeChange, currentTheme: currentTheme, extraMenuItems: extraMenuItems, trustPicture: trustPicture = false, AccountMenuLoggedOutState: AccountMenuLoggedOutState, AccountMenuTrigger: AccountMenuTrigger })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $ffCOo.NavigationAnalyticsContext), {
        data: (0, $hoiF1.ANALYTICS_CONTEXT),
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $axaJh.AccountMenuIntlProvider), {
            children: logInLink ? /*#__PURE__*/ (0, $7UHDa.jsx)(AccountMenuLoggedOutState, {
                testId: testId && `${testId}--logged-out-state`,
                logInLink: logInLink
            }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lUIjo.AccountMenuPopup), {
                testId: testId,
                picture: picture,
                trustPicture: trustPicture,
                email: email,
                AccountMenuTrigger: AccountMenuTrigger,
                content: ({ onClose: closePopup })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $8rsbZ.AccountMenuContent), {
                        testId: testId && `${testId}--content`,
                        closePopup: closePopup,
                        name: name,
                        picture: picture,
                        email: email,
                        managedBy: managedBy,
                        manageProfileLink: manageProfileLink,
                        viewProfileLink: viewProfileLink,
                        onViewProfileClick: onViewProfileClick,
                        switchAccountLink: switchAccountLink,
                        logOutLink: logOutLink,
                        onThemeChange: onThemeChange,
                        currentTheme: currentTheme,
                        extraMenuItems: extraMenuItems
                    })
            })
        })
    });

});
parcelRegister("8rsbZ", function(module, exports) {

$parcel$export(module.exports, "AccountMenuContent", () => $32d891c6a46c5c31$export$49c2771125e1e9f1);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $4jR19 = parcelRequire("4jR19");

var $7TH2w = parcelRequire("7TH2w");

var $inPa6 = parcelRequire("inPa6");

var $jK29N = parcelRequire("jK29N");

var $14Meb = parcelRequire("14Meb");

var $lebfc = parcelRequire("lebfc");

var $6767u = parcelRequire("6767u");

var $jcx02 = parcelRequire("jcx02");

var $0bdML = parcelRequire("0bdML");

var $3L3Ah = parcelRequire("3L3Ah");

var $cGtPE = parcelRequire("cGtPE");
var $2SlZp = parcelRequire("2SlZp");
var $7rvPL = parcelRequire("7rvPL");

var $dTk3A = parcelRequire("dTk3A");

var $hoiF1 = parcelRequire("hoiF1");

var $fV8vk = parcelRequire("fV8vk");

var $9TfMd = parcelRequire("9TfMd");

var $gwrgp = parcelRequire("gwrgp");
const $32d891c6a46c5c31$export$49c2771125e1e9f1 = ({ testId: testId, closePopup: closePopup, name: name, picture: picture, email: email, managedBy: managedBy, manageProfileLink: manageProfileLink, viewProfileLink: viewProfileLink, onViewProfileClick: onViewProfileClick, switchAccountLink: switchAccountLink, logOutLink: logOutLink, onThemeChange: onThemeChange, currentTheme: currentTheme, extraMenuItems: extraMenuItems = null })=>{
    const themeSwitcherProps = onThemeChange && currentTheme;
    const shouldRenderProfileThemeSwitcherSection = Boolean(viewProfileLink || manageProfileLink || themeSwitcherProps);
    return /*#__PURE__*/ (0, $3jLHL.jsx)($32d891c6a46c5c31$var$Container, {
        "data-testid": testId
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $2SlZp.default), null, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $7rvPL.default), null, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $fV8vk.AccountDetails), {
        testId: testId && `${testId}--details`,
        name: name,
        picture: picture,
        email: email,
        managedBy: managedBy
    })), shouldRenderProfileThemeSwitcherSection && /*#__PURE__*/ (0, $3jLHL.jsx)((0, $7rvPL.default), null, viewProfileLink && /*#__PURE__*/ (0, $3jLHL.jsx)($32d891c6a46c5c31$var$ViewProfileLink, {
        onClick: onViewProfileClick,
        testId: testId && `${testId}--view-profile`,
        href: viewProfileLink,
        closePopup: closePopup
    }), manageProfileLink && /*#__PURE__*/ (0, $3jLHL.jsx)($32d891c6a46c5c31$var$ManageProfileLink, {
        testId: testId && `${testId}--manage-profile`,
        href: manageProfileLink,
        closePopup: closePopup
    }), themeSwitcherProps && /*#__PURE__*/ (0, $3jLHL.jsx)((0, $9TfMd.ThemeSwitcher), {
        testId: testId && `${testId}--theme-switcher`,
        onThemeChange: onThemeChange,
        currentTheme: currentTheme
    })), extraMenuItems, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $7rvPL.default), {
        hasSeparator: shouldRenderProfileThemeSwitcherSection
    }, switchAccountLink && /*#__PURE__*/ (0, $3jLHL.jsx)($32d891c6a46c5c31$var$SwitchAccountLink, {
        testId: testId && `${testId}--switch-account`,
        href: switchAccountLink,
        closePopup: closePopup
    }), /*#__PURE__*/ (0, $3jLHL.jsx)($32d891c6a46c5c31$var$LogOutLink, {
        testId: testId && `${testId}--log-out`,
        href: logOutLink,
        closePopup: closePopup
    }))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $32d891c6a46c5c31$var$Container = (0, $gwrgp.default)("div", {
    target: "evherry0"
})({
    boxSizing: 'border-box',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minWidth: (0, $dTk3A.gridSize)() * 38
});
const $32d891c6a46c5c31$var$ViewProfileLink = ({ testId: testId, href: href, onClick: onClick, closePopup: closePopup })=>/*#__PURE__*/ (0, $3jLHL.jsx)($32d891c6a46c5c31$var$Link, {
        testId: testId,
        href: href,
        onClick: onClick,
        icon: /*#__PURE__*/ (0, $3jLHL.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6767u))), {
            color: "currentColor",
            label: "",
            LEGACY_size: "medium",
            LEGACY_fallbackIcon: (0, $0bdML.default)
        }),
        closePopup: closePopup,
        actionSubjectId: "viewProfileLink"
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $4jR19.default), {
        id: "identity.account-menu.account-details.view-profile-tooltip",
        defaultMessage: "Profile"
    }));
const $32d891c6a46c5c31$var$ManageProfileLink = ({ testId: testId, href: href, closePopup: closePopup })=>/*#__PURE__*/ (0, $3jLHL.jsx)($32d891c6a46c5c31$var$Link, {
        testId: testId,
        href: href,
        icon: /*#__PURE__*/ (0, $3jLHL.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($14Meb))), {
            color: "currentColor",
            label: "",
            LEGACY_size: "medium"
        }),
        closePopup: closePopup,
        actionSubjectId: "manageProfileLink",
        target: "_blank",
        rel: "noopener"
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $4jR19.default), {
        id: "identity.account-menu.account-details.manage-profile-link",
        defaultMessage: "Account settings"
    }));
const $32d891c6a46c5c31$var$SwitchAccountLink = ({ testId: testId, href: href, closePopup: closePopup })=>/*#__PURE__*/ (0, $3jLHL.jsx)($32d891c6a46c5c31$var$Link, {
        testId: testId,
        icon: /*#__PURE__*/ (0, $3jLHL.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lebfc))), {
            color: "currentColor",
            label: "",
            LEGACY_size: "medium",
            LEGACY_fallbackIcon: (0, $jcx02.default)
        }),
        href: href,
        closePopup: closePopup,
        actionSubjectId: "switchAccountLink"
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $4jR19.default), {
        id: "identity.account-menu.account-menu-content.switch-account-button",
        defaultMessage: "Switch account"
    }));
const $32d891c6a46c5c31$var$LogOutLink = ({ testId: testId, href: href, closePopup: closePopup })=>/*#__PURE__*/ (0, $3jLHL.jsx)($32d891c6a46c5c31$var$Link, {
        testId: testId,
        icon: /*#__PURE__*/ (0, $3jLHL.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jK29N))), {
            color: "currentColor",
            label: "",
            LEGACY_size: "medium",
            LEGACY_fallbackIcon: (0, $3L3Ah.default)
        }),
        href: href,
        closePopup: closePopup,
        actionSubjectId: "logOutLink"
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $4jR19.default), {
        id: "identity.account-menu.account-menu-content.log-out-button",
        defaultMessage: "Log out"
    }));
const $32d891c6a46c5c31$var$Link = ({ testId: testId, closePopup: closePopup, icon: icon, href: href, onClick: onClick, actionSubjectId: actionSubjectId, children: children, ...props })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handleClick = (0, $gwFzn.useCallback)((event)=>{
        const analyticsEvent = createAnalyticsEvent({
            eventType: (0, $7TH2w.UI_EVENT_TYPE),
            action: 'clicked',
            actionSubject: 'menuLinkItem',
            actionSubjectId: actionSubjectId
        });
        const clone = analyticsEvent.clone();
        if (clone) clone.fire((0, $hoiF1.NAVIGATION_CHANNEL));
        onClick?.(event, analyticsEvent);
        closePopup?.(event);
    }, [
        createAnalyticsEvent,
        onClick,
        closePopup,
        actionSubjectId
    ]);
    return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $cGtPE.default), {
        testId: testId,
        iconBefore: icon,
        href: href,
        onClick: handleClick,
        ...props
    }, children);
};

});
parcelRegister("jcx02", function(module, exports) {

$parcel$export(module.exports, "default", () => $48bcdcdb7e25d1d2$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $id7ja = parcelRequire("id7ja");
const $48bcdcdb7e25d1d2$var$PeopleIconGlyph = (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
            fill: "currentColor",
            d: "M10.523 11.3a4.5 4.5 0 0 1 4.5 4.5v2.5a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2v-2.5a4.5 4.5 0 0 1 4.5-4.5h3Zm6 0 .212.005a4.5 4.5 0 0 1 4.283 4.277l.005.218v2.5l-.005.15a2 2 0 0 1-1.838 1.844l-.157.006h-2l-.116-.007a1 1 0 0 1 0-1.986l.116-.007h2v-2.5l-.005-.165a2.5 2.5 0 0 0-2.33-2.33l-.165-.005h-.5l-.116-.007a1 1 0 0 1 0-1.986l.116-.007h.5Zm-6 2h-3a2.5 2.5 0 0 0-2.5 2.5v2.5h8v-2.5a2.5 2.5 0 0 0-2.5-2.5Zm-1.5-10a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7Zm4.61.294a3.5 3.5 0 1 1 0 6.412 1 1 0 0 1 .694-1.872l.24.09a1.5 1.5 0 1 0 .012-2.852l-.252.094a1 1 0 0 1-.693-1.872ZM9.024 5.3a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z"
        })
    });
/**
 * __PeopleIcon__
 */ const $48bcdcdb7e25d1d2$var$PeopleIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $id7ja.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $48bcdcdb7e25d1d2$var$PeopleIconGlyph
    });
var $48bcdcdb7e25d1d2$export$2e2bcd8739ae039 = $48bcdcdb7e25d1d2$var$PeopleIcon;

});

parcelRegister("0bdML", function(module, exports) {

$parcel$export(module.exports, "default", () => $f954c1e6dbc22ce2$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $id7ja = parcelRequire("id7ja");
const $f954c1e6dbc22ce2$var$PersonIconGlyph = (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
            fill: "currentColor",
            d: "M13.523 11.3a4.504 4.504 0 0 1 4.478 4.063l.017.218.005.219v2.5c0 .964-.685 1.78-1.66 1.966l-.165.025-.175.009h-8c-.964 0-1.78-.686-1.966-1.66l-.025-.166-.009-.174v-2.5a4.504 4.504 0 0 1 4.064-4.478l.217-.017.22-.005h3Zm0 2H10.55l-.165.003a2.5 2.5 0 0 0-2.356 2.332l-.006.165-.001 2.442.001.058 7.943.002.057-.002v-2.473l-.003-.165a2.5 2.5 0 0 0-2.332-2.357l-.165-.005Zm-1.5-10a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7Zm0 2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z"
        })
    });
/**
 * __PersonIcon__
 */ const $f954c1e6dbc22ce2$var$PersonIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $id7ja.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $f954c1e6dbc22ce2$var$PersonIconGlyph
    });
var $f954c1e6dbc22ce2$export$2e2bcd8739ae039 = $f954c1e6dbc22ce2$var$PersonIcon;

});

parcelRegister("3L3Ah", function(module, exports) {

$parcel$export(module.exports, "default", () => $a874457b7ff0d2e7$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $id7ja = parcelRequire("id7ja");
const $a874457b7ff0d2e7$var$SignOutIconGlyph = (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
            fill: "currentColor",
            d: "m6.023 4.3-.149.005A2 2 0 0 0 4.024 6.3v12l.005.15a2 2 0 0 0 1.994 1.85h5l.117-.007a1 1 0 0 0-.117-1.993h-5v-12h5l.117-.007a1 1 0 0 0-.117-1.993h-5Zm9.293 4.293a1 1 0 0 0-.083 1.32l.084.094 1.292 1.292H9.023a1 1 0 0 0-.125 1.993l.125.008 7.586-.001-1.293 1.294a1 1 0 0 0-.083 1.32l.084.094a1 1 0 0 0 1.32.083l.094-.083 2.974-2.975c.096-.09.175-.198.23-.32l.011-.028a.757.757 0 0 0 .031-.083l.008-.027a.767.767 0 0 0 .02-.08l.007-.042a.767.767 0 0 0 .011-.133v-.039c0-.024-.002-.05-.004-.074l.004.094a1 1 0 0 0-.022-.215l-.008-.031a.807.807 0 0 0-.021-.074l-.018-.046a.64.64 0 0 0-.025-.062l-.019-.035a.64.64 0 0 0-.049-.083.667.667 0 0 0-.047-.07l-.084-.093-3-2.998a1 1 0 0 0-1.414 0Z"
        })
    });
/**
 * __SignOutIcon__
 */ const $a874457b7ff0d2e7$var$SignOutIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $id7ja.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $a874457b7ff0d2e7$var$SignOutIconGlyph
    });
var $a874457b7ff0d2e7$export$2e2bcd8739ae039 = $a874457b7ff0d2e7$var$SignOutIcon;

});

parcelRegister("fV8vk", function(module, exports) {

$parcel$export(module.exports, "AccountDetails", () => $9f54f6e7b6ed0a29$export$66e04d0aacdb3b2);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $3jLHL = parcelRequire("3jLHL");

var $4jR19 = parcelRequire("4jR19");

var $6767u = parcelRequire("6767u");

var $0bdML = parcelRequire("0bdML");

var $iXCQx = parcelRequire("iXCQx");

var $6fnsQ = parcelRequire("6fnsQ");

var $dTk3A = parcelRequire("dTk3A");

var $bpR40 = parcelRequire("bpR40");

var $doWlG = parcelRequire("doWlG");

var $gwrgp = parcelRequire("gwrgp");
const $9f54f6e7b6ed0a29$export$66e04d0aacdb3b2 = ({ testId: testId, name: name, picture: picture, email: email, managedBy: managedBy })=>/*#__PURE__*/ (0, $3jLHL.jsx)($9f54f6e7b6ed0a29$var$Container, {
        "data-testid": testId
    }, managedBy && /*#__PURE__*/ (0, $3jLHL.jsx)($9f54f6e7b6ed0a29$var$ManagedBy, null, /*#__PURE__*/ (0, $3jLHL.jsx)($9f54f6e7b6ed0a29$var$PersonIconWrapper, null, /*#__PURE__*/ (0, $3jLHL.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6767u))), {
        color: "currentColor",
        label: "",
        LEGACY_size: "small",
        LEGACY_fallbackIcon: (0, $0bdML.default)
    })), /*#__PURE__*/ (0, $3jLHL.jsx)((0, $4jR19.default), {
        id: "identity.account-menu.account-menu-details.managed-account",
        defaultMessage: "This account is managed by <b>{managedBy}</b>",
        values: {
            b: (text)=>/*#__PURE__*/ (0, $3jLHL.jsx)((0, $iXCQx.default), {
                    as: "strong",
                    size: "small",
                    color: "inherit"
                }, text),
            managedBy: managedBy
        }
    })), /*#__PURE__*/ (0, $3jLHL.jsx)($9f54f6e7b6ed0a29$var$Content, {
        hasHeader: !!managedBy
    }, /*#__PURE__*/ (0, $3jLHL.jsx)($9f54f6e7b6ed0a29$var$Profile, {
        testId: testId,
        name: name,
        picture: picture,
        email: email
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9f54f6e7b6ed0a29$var$Container = (0, $gwrgp.default)("section", {
    target: "e3lis060"
})({
    display: 'flex',
    flexDirection: 'column',
    margin: `0 ${"var(--ds-space-100, 8px)"}`
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9f54f6e7b6ed0a29$var$ManagedBy = (0, $gwrgp.default)("small", {
    target: "e3lis061"
})({
    display: 'box',
    margin: '0px',
    padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-100, 8px)"}`,
    textAlign: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `${(0, $dTk3A.borderRadius)()}px ${(0, $dTk3A.borderRadius)()}px 0 0`,
    background: `var(--ds-background-information, ${(0, $6fnsQ.B50)})`,
    color: "var(--ds-text-subtle, #44546F)"
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9f54f6e7b6ed0a29$var$PersonIconWrapper = (0, $gwrgp.default)("span", {
    target: "e3lis062"
})({
    name: "1d1sf9j",
    styles: "margin-right:var(--ds-space-050, 4px);& > span{width:12px;height:12px;}"
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9f54f6e7b6ed0a29$var$Content = (0, $gwrgp.default)("div", {
    target: "e3lis063"
})({
    display: 'flex',
    flexDirection: 'column',
    background: `var(--ds-surface-sunken, ${(0, $6fnsQ.N20A)})`
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
({ hasHeader: hasHeader })=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderRadius: hasHeader ? `0 0 ${(0, $dTk3A.borderRadius)()}px ${(0, $dTk3A.borderRadius)()}px` : `${(0, $dTk3A.borderRadius)()}px`
    }));
const $9f54f6e7b6ed0a29$var$Profile = ({ name: name, email: email, picture: picture, testId: testId })=>/*#__PURE__*/ (0, $3jLHL.jsx)($9f54f6e7b6ed0a29$var$ProfileWrapper, null, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $bpR40.ProfilePicture), {
        src: picture,
        size: (0, $dTk3A.gridSize)() * 8,
        testId: testId && `${testId}--picture`
    }), /*#__PURE__*/ (0, $3jLHL.jsx)($9f54f6e7b6ed0a29$var$NameAndEmail, null, /*#__PURE__*/ (0, $3jLHL.jsx)($9f54f6e7b6ed0a29$var$DisplayName, {
        "data-testid": testId && `${testId}--name`
    }, name || /*#__PURE__*/ (0, $3jLHL.jsx)((0, $doWlG.SkeletonText), {
        length: "6em"
    })), /*#__PURE__*/ (0, $3jLHL.jsx)($9f54f6e7b6ed0a29$var$EmailAddress, {
        "data-testid": testId && `${testId}--email`
    }, email || /*#__PURE__*/ (0, $3jLHL.jsx)((0, $doWlG.SkeletonText), {
        length: "10em"
    }))));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9f54f6e7b6ed0a29$var$ProfileWrapper = (0, $gwrgp.default)("div", {
    target: "e3lis064"
})({
    display: 'flex',
    flexDirection: 'row',
    margin: `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-200, 16px)"}`
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9f54f6e7b6ed0a29$var$NameAndEmail = (0, $gwrgp.default)("div", {
    target: "e3lis065"
})({
    display: 'flex',
    flexDirection: 'column',
    margin: `auto 0 auto ${"var(--ds-space-200, 16px)"}`
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9f54f6e7b6ed0a29$var$DisplayName = (0, $gwrgp.default)("h3", {
    target: "e3lis066"
})({
    color: `var(--ds-text, ${(0, $6fnsQ.N800)})`,
    margin: 0
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9f54f6e7b6ed0a29$var$EmailAddress = (0, $gwrgp.default)("p", {
    target: "e3lis067"
})({
    name: "1gxllnr",
    styles: "margin-top:var(--ds-space-025, 2px);color:var(--ds-text-subtlest, #626F86);font-weight:var(--ds-font-weight-regular, 400);"
});

});
parcelRegister("bpR40", function(module, exports) {

$parcel$export(module.exports, "ProfilePicture", () => $af0b6f5882cf7450$export$2d75367b6e042d67);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");

var $5cJSs = parcelRequire("5cJSs");

var $6fnsQ = parcelRequire("6fnsQ");

var $asAwU = parcelRequire("asAwU");
const $af0b6f5882cf7450$var$imgStyles = (0, $3jLHL.css)({
    display: 'block',
    borderRadius: '50%'
});
const $af0b6f5882cf7450$export$2d75367b6e042d67 = ({ testId: testId, src: src, size: size, className: className })=>{
    const state = (0, $asAwU.useImageState)(src || '');
    const displayImage = src && state === 'loaded';
    const displayFallback = src && state === 'error';
    const displaySkeleton = !displayImage && !displayFallback;
    return /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: {
            width: size,
            height: size,
            ...displaySkeleton && {
                borderRadius: '50%',
                backgroundColor: `var(--ds-background-neutral, ${0, $6fnsQ.N20A})`
            },
            '& svg, & img': {
                width: size,
                height: size
            }
        }
    }, displayImage && /*#__PURE__*/ (0, $3jLHL.jsx)("img", {
        "data-testid": testId && `${testId}--img`,
        src: src,
        css: $af0b6f5882cf7450$var$imgStyles
    }), displayFallback && /*#__PURE__*/ (0, $3jLHL.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5cJSs))), {
        spacing: "spacious",
        testId: testId && `${testId}--fallback`,
        label: "",
        color: `var(--ds-text-subtlest, ${(0, $6fnsQ.N90)})`,
        LEGACY_secondaryColor: `var(--ds-text-inverse, ${(0, $6fnsQ.N0)})`
    }));
};

});

parcelRegister("doWlG", function(module, exports) {

$parcel$export(module.exports, "SkeletonText", () => $947a2399b57871ec$export$cb6ddd830302c2a8);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $6fnsQ = parcelRequire("6fnsQ");

var $gwrgp = parcelRequire("gwrgp");
const $947a2399b57871ec$export$cb6ddd830302c2a8 = (0, $gwrgp.default)("span", {
    target: "ej73sxo0"
})({
    display: 'inline-block',
    height: '1em',
    borderRadius: '0.5em',
    backgroundColor: `var(--ds-background-neutral, ${(0, $6fnsQ.N20A)})`
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
({ length: length })=>({
        width: length
    }));

});


parcelRegister("9TfMd", function(module, exports) {

$parcel$export(module.exports, "ThemeSwitcher", () => $a29165a1bb79a351$export$9d63163ee2173b37);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $52EPl = parcelRequire("52EPl");
var $3sMdn = parcelRequire("3sMdn");

var $28NpI = parcelRequire("28NpI");

var $ldIK0 = parcelRequire("ldIK0");

var $gc08d = parcelRequire("gc08d");

var $56M4r = parcelRequire("56M4r");

var $8Tg40 = parcelRequire("8Tg40");

var $jDYyu = parcelRequire("jDYyu");

var $gUtc8 = parcelRequire("gUtc8");

var $gwrgp = parcelRequire("gwrgp");
const $a29165a1bb79a351$export$9d63163ee2173b37 = ({ testId: testId, onThemeChange: onThemeChange, currentTheme: currentTheme })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $52EPl.default), {
        testId: testId,
        placement: "auto-start",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $56M4r.default), {
                ref: triggerRef,
                onClick: (event)=>event.stopPropagation(),
                iconBefore: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($28NpI))), {
                    color: "currentColor",
                    label: "",
                    LEGACY_fallbackIcon: (0, $gc08d.default)
                }),
                iconAfter: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ldIK0))), {
                    color: "currentColor",
                    label: ""
                }),
                ...props,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    id: "identity.account-menu.theme-switcher.theme-button",
                    defaultMessage: "Theme"
                })
            }),
        children: $a29165a1bb79a351$var$themeOptions.map(({ label: label, value: value, thumbnail: thumbnail })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $3sMdn.default), {
                testId: `${testId}--radio-${value}`,
                id: value,
                onClick: ()=>onThemeChange(value),
                isSelected: currentTheme === value,
                children: /*#__PURE__*/ (0, $7UHDa.jsxs)($a29165a1bb79a351$var$RadioLabelContainer, {
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)("img", {
                            src: thumbnail,
                            width: 64,
                            height: 48,
                            alt: ""
                        }),
                        label
                    ]
                })
            }, value))
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a29165a1bb79a351$var$RadioLabelContainer = (0, $gwrgp.default)("div", {
    target: "e1q43w0o0"
})({
    name: "ajbi8a",
    styles: "display:flex;align-items:center;gap:var(--ds-space-150, 12px);"
});
const $a29165a1bb79a351$var$messages = (0, $2nPZH.defineMessages)({
    light: {
        id: "identity.account-menu.theme-switcher.light.option",
        defaultMessage: "Light"
    },
    dark: {
        id: "identity.account-menu.theme-switcher.dark.option",
        defaultMessage: "Dark"
    },
    matchBrowser: {
        id: "identity.account-menu.theme-switcher.match-browser.option",
        defaultMessage: "Match browser"
    }
});
const $a29165a1bb79a351$var$themeOptions = [
    {
        label: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...$a29165a1bb79a351$var$messages.light
        }),
        value: 'light',
        thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($jDYyu)))
    },
    {
        label: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...$a29165a1bb79a351$var$messages.dark
        }),
        value: 'dark',
        thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($8Tg40)))
    },
    {
        label: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...$a29165a1bb79a351$var$messages.matchBrowser
        }),
        value: 'auto',
        thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($gUtc8)))
    }
];

});
parcelRegister("gc08d", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5da5685d59d9455$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $id7ja = parcelRequire("id7ja");
const $c5da5685d59d9455$var$ThemeIconGlyph = (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 20V4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
            fill: "currentColor"
        })
    });
/**
 * __ThemeIcon__
 */ const $c5da5685d59d9455$var$ThemeIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $id7ja.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $c5da5685d59d9455$var$ThemeIconGlyph
    });
var $c5da5685d59d9455$export$2e2bcd8739ae039 = $c5da5685d59d9455$var$ThemeIcon;

});

parcelRegister("8Tg40", function(module, exports) {
module.exports = new URL("dark-mode.c2768bcf.svg", import.meta.url).toString();

});

parcelRegister("jDYyu", function(module, exports) {
module.exports = new URL("light-mode.e7c3914f.svg", import.meta.url).toString();

});

parcelRegister("gUtc8", function(module, exports) {
module.exports = new URL("match-browser.a2bb9bea.svg", import.meta.url).toString();

});



parcelRegister("axaJh", function(module, exports) {

$parcel$export(module.exports, "AccountMenuIntlProvider", () => $7907dead2a23af82$export$6c1f1571e3dd1b34);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $hlhtG = parcelRequire("hlhtG");
var $dBxQj = parcelRequire("dBxQj");

var $3Tnjk = parcelRequire("3Tnjk");
const $7907dead2a23af82$export$6c1f1571e3dd1b34 = ({ children: children })=>{
    const { locale: locale } = (0, $dBxQj.default)();
    const messages = $7907dead2a23af82$var$useMessages(locale);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hlhtG.default), {
        locale: locale,
        messages: messages,
        children: children
    });
};
const $7907dead2a23af82$var$useMessages = (locale)=>{
    const [messages, setMessages] = (0, $gwFzn.useState)();
    (0, $gwFzn.useEffect)(()=>{
        if (/^en(-US)?$/i.exec(locale)) // Use fallback messages, which are already US English
        setMessages(undefined);
        else {
            let cancelled = false;
            $7907dead2a23af82$var$loadMessages(locale).catch((_error)=>undefined) // TODO: Log error somehow (analytics?)
            .then((messages)=>{
                if (!cancelled) setMessages(messages);
            });
            return ()=>{
                cancelled = true;
            };
        }
    }, [
        locale,
        setMessages
    ]);
    return messages;
};
const $7907dead2a23af82$var$loadMessages = async (locale)=>{
    let [language, region = ''] = locale.split('-', 2);
    language = language.toLowerCase();
    region = region.toUpperCase();
    return (await ((0, $3Tnjk.default)[`${language}_${region}`] || (0, $3Tnjk.default)[language])?.())?.default;
};

});
parcelRegister("3Tnjk", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d8a7a824f3555db$export$2e2bcd8739ae039);
/**
 * NOTE:
 *
 * This file is automatically generated by scripts/generate-i18n-index.ts.
 * DO NOT UPDATE IT BY HAND. Instead, run yarn generate-i18n-index.
 */ 










































const $6d8a7a824f3555db$var$lazyMessages = {
    cs: ()=>(parcelRequire("jR9du")),
    cs_CZ: ()=>(parcelRequire("d6lK3")),
    da: ()=>(parcelRequire("3zxa2")),
    da_DK: ()=>(parcelRequire("3QoVF")),
    de: ()=>(parcelRequire("5RTsX")),
    de_DE: ()=>(parcelRequire("ayHFw")),
    en_GB: ()=>(parcelRequire("elFbH")),
    en_ZZ: ()=>(parcelRequire("9gm0H")),
    es: ()=>(parcelRequire("CUbUx")),
    fi: ()=>(parcelRequire("1AbL9")),
    fi_FI: ()=>(parcelRequire("aECnW")),
    fr: ()=>(parcelRequire("gh86S")),
    fr_FR: ()=>(parcelRequire("dz0v3")),
    hu: ()=>(parcelRequire("3ipEf")),
    hu_HU: ()=>(parcelRequire("9D5lB")),
    it: ()=>(parcelRequire("fEIq6")),
    it_IT: ()=>(parcelRequire("d9T1p")),
    ja: ()=>(parcelRequire("2lSg4")),
    ja_JP: ()=>(parcelRequire("lqSoo")),
    ko: ()=>(parcelRequire("7LY9o")),
    ko_KR: ()=>(parcelRequire("kcu6S")),
    nb: ()=>(parcelRequire("gNRF1")),
    nb_NO: ()=>(parcelRequire("fWMXx")),
    nl: ()=>(parcelRequire("aDuXs")),
    nl_NL: ()=>(parcelRequire("33UOX")),
    pl: ()=>(parcelRequire("2uNZ1")),
    pl_PL: ()=>(parcelRequire("jM3Yt")),
    pt_BR: ()=>(parcelRequire("7usWs")),
    ru: ()=>(parcelRequire("2gcJ6")),
    ru_RU: ()=>(parcelRequire("cKS3S")),
    sv: ()=>(parcelRequire("30I5p")),
    sv_SE: ()=>(parcelRequire("jMdpO")),
    th: ()=>(parcelRequire("6aKwN")),
    th_TH: ()=>(parcelRequire("gRP5k")),
    tr: ()=>(parcelRequire("hxBsd")),
    tr_TR: ()=>(parcelRequire("7b8Jr")),
    uk: ()=>(parcelRequire("7TxDg")),
    uk_UA: ()=>(parcelRequire("7vLFG")),
    vi: ()=>(parcelRequire("aWM06")),
    vi_VN: ()=>(parcelRequire("9WGMh")),
    zh: ()=>(parcelRequire("fDygl")),
    zh_CN: ()=>(parcelRequire("cuT7I")),
    zh_TW: ()=>(parcelRequire("77tHO"))
};
var $6d8a7a824f3555db$export$2e2bcd8739ae039 = $6d8a7a824f3555db$var$lazyMessages;

});
parcelRegister("jR9du", function(module, exports) {

let $e74a1dc0b65239ae$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e74a1dc0b65239ae$var$load("49f46").then(()=>parcelRequire('5IqdJ'));

});

parcelRegister("d6lK3", function(module, exports) {

let $989cb36336a94ceb$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $989cb36336a94ceb$var$load("jQPB7").then(()=>parcelRequire('fayG1'));

});

parcelRegister("3zxa2", function(module, exports) {

let $299e5d12ae3342a1$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $299e5d12ae3342a1$var$load("88bR1").then(()=>parcelRequire('UHBCO'));

});

parcelRegister("3QoVF", function(module, exports) {

let $2cc990d64715c945$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $2cc990d64715c945$var$load("bwD1u").then(()=>parcelRequire('9pe3F'));

});

parcelRegister("5RTsX", function(module, exports) {

let $445ced5f43d16c81$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $445ced5f43d16c81$var$load("85kOD").then(()=>parcelRequire('1pUDx'));

});

parcelRegister("ayHFw", function(module, exports) {

let $7afef41458057f3f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $7afef41458057f3f$var$load("R2BG5").then(()=>parcelRequire('iqlPg'));

});

parcelRegister("elFbH", function(module, exports) {

let $a722f9dcbf3d90a4$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a722f9dcbf3d90a4$var$load("2goda").then(()=>parcelRequire('iOI8t'));

});

parcelRegister("9gm0H", function(module, exports) {

let $6be6ae73a9c1199d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $6be6ae73a9c1199d$var$load("gjxqp").then(()=>parcelRequire('bhbO7'));

});

parcelRegister("CUbUx", function(module, exports) {

let $074f231bf1713ec9$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $074f231bf1713ec9$var$load("1S2jF").then(()=>parcelRequire('edwAF'));

});

parcelRegister("1AbL9", function(module, exports) {

let $12724671d9f2e27b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $12724671d9f2e27b$var$load("eERmJ").then(()=>parcelRequire('e4doi'));

});

parcelRegister("aECnW", function(module, exports) {

let $7c1b6a53998bfd33$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $7c1b6a53998bfd33$var$load("8rk64").then(()=>parcelRequire('6dE10'));

});

parcelRegister("gh86S", function(module, exports) {

let $bd94865391455386$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $bd94865391455386$var$load("bpktO").then(()=>parcelRequire('gBarX'));

});

parcelRegister("dz0v3", function(module, exports) {

let $9dfeee851fe806fc$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $9dfeee851fe806fc$var$load("aC2ty").then(()=>parcelRequire('donzV'));

});

parcelRegister("3ipEf", function(module, exports) {

let $2666f2b7d9fa5557$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $2666f2b7d9fa5557$var$load("lmJBr").then(()=>parcelRequire('dMOpd'));

});

parcelRegister("9D5lB", function(module, exports) {

let $702be777bb09535d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $702be777bb09535d$var$load("lVBNt").then(()=>parcelRequire('h0DUZ'));

});

parcelRegister("fEIq6", function(module, exports) {

let $b65d0c50178f83ad$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b65d0c50178f83ad$var$load("lnHpS").then(()=>parcelRequire('edoS5'));

});

parcelRegister("d9T1p", function(module, exports) {

let $9946cbc63457b067$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $9946cbc63457b067$var$load("kEBAh").then(()=>parcelRequire('1MVOF'));

});

parcelRegister("2lSg4", function(module, exports) {

let $1b67a17b788bd4b0$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $1b67a17b788bd4b0$var$load("3ZAy1").then(()=>parcelRequire('gyzZK'));

});

parcelRegister("lqSoo", function(module, exports) {

let $f9a637e31440248e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f9a637e31440248e$var$load("fDXOw").then(()=>parcelRequire('k5CKC'));

});

parcelRegister("7LY9o", function(module, exports) {

let $5a8b94ce002ff1d6$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $5a8b94ce002ff1d6$var$load("45dhs").then(()=>parcelRequire('dbyax'));

});

parcelRegister("kcu6S", function(module, exports) {

let $eb4c48da4ece5ef5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $eb4c48da4ece5ef5$var$load("grGen").then(()=>parcelRequire('aADgd'));

});

parcelRegister("gNRF1", function(module, exports) {

let $c3bad8d362aed121$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c3bad8d362aed121$var$load("4iqE9").then(()=>parcelRequire('AmvTn'));

});

parcelRegister("fWMXx", function(module, exports) {

let $b9c2401d62d58ce3$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b9c2401d62d58ce3$var$load("bAyJY").then(()=>parcelRequire('2bGC8'));

});

parcelRegister("aDuXs", function(module, exports) {

let $7be58f82f1e9a382$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $7be58f82f1e9a382$var$load("51EOq").then(()=>parcelRequire('9SCOA'));

});

parcelRegister("33UOX", function(module, exports) {

let $23adba551db07dcd$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $23adba551db07dcd$var$load("d5GjE").then(()=>parcelRequire('3ahnS'));

});

parcelRegister("2uNZ1", function(module, exports) {

let $1d1527c25b94d018$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $1d1527c25b94d018$var$load("4ILPZ").then(()=>parcelRequire('6UenK'));

});

parcelRegister("jM3Yt", function(module, exports) {

let $e65595402114ff58$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e65595402114ff58$var$load("6QVYs").then(()=>parcelRequire('9rAua'));

});

parcelRegister("7usWs", function(module, exports) {

let $5741c8fb5619cbb7$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $5741c8fb5619cbb7$var$load("7HuII").then(()=>parcelRequire('46yCo'));

});

parcelRegister("2gcJ6", function(module, exports) {

let $1a56f2a035700dc7$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $1a56f2a035700dc7$var$load("iYxvq").then(()=>parcelRequire('9AItb'));

});

parcelRegister("cKS3S", function(module, exports) {

let $9493b76462a4d20e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $9493b76462a4d20e$var$load("8kHli").then(()=>parcelRequire('c4u14'));

});

parcelRegister("30I5p", function(module, exports) {

let $231391c7d2bda944$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $231391c7d2bda944$var$load("dqRWB").then(()=>parcelRequire('jiubQ'));

});

parcelRegister("jMdpO", function(module, exports) {

let $e65ce801c562ab1f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e65ce801c562ab1f$var$load("bYWK5").then(()=>parcelRequire('cDjZR'));

});

parcelRegister("6aKwN", function(module, exports) {

let $47e7c4bd892a3dc0$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $47e7c4bd892a3dc0$var$load("k0u9s").then(()=>parcelRequire('ix6Ww'));

});

parcelRegister("gRP5k", function(module, exports) {

let $c47939028ccdd8ad$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c47939028ccdd8ad$var$load("imObn").then(()=>parcelRequire('hIGnW'));

});

parcelRegister("hxBsd", function(module, exports) {

let $cc52925a85150340$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $cc52925a85150340$var$load("chSc4").then(()=>parcelRequire('10LAa'));

});

parcelRegister("7b8Jr", function(module, exports) {

let $53a055758589a7da$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $53a055758589a7da$var$load("dfeY8").then(()=>parcelRequire('hvJbJ'));

});

parcelRegister("7TxDg", function(module, exports) {

let $5bf7c225812eac0a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $5bf7c225812eac0a$var$load("fvaoj").then(()=>parcelRequire('3mPtI'));

});

parcelRegister("7vLFG", function(module, exports) {

let $5780682b44677b97$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $5780682b44677b97$var$load("lT1ej").then(()=>parcelRequire('6zPsL'));

});

parcelRegister("aWM06", function(module, exports) {

let $7f848e1877b192a2$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $7f848e1877b192a2$var$load("8OH5J").then(()=>parcelRequire('jUZEM'));

});

parcelRegister("9WGMh", function(module, exports) {

let $73dab6974a8f5af7$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $73dab6974a8f5af7$var$load("hV9Rr").then(()=>parcelRequire('3Nmej'));

});

parcelRegister("fDygl", function(module, exports) {

let $b6251361778a665d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b6251361778a665d$var$load("k4zbq").then(()=>parcelRequire('cMIbn'));

});

parcelRegister("cuT7I", function(module, exports) {

let $91930bb8b7e12f16$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $91930bb8b7e12f16$var$load("1cNBX").then(()=>parcelRequire('9Z0w0'));

});

parcelRegister("77tHO", function(module, exports) {

let $52f03acb414a23b8$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $52f03acb414a23b8$var$load("ii6TT").then(()=>parcelRequire('hru40'));

});



parcelRegister("lUIjo", function(module, exports) {

$parcel$export(module.exports, "AccountMenuPopup", () => $0a9efcd3d36ca5be$export$473cb05bf335b0e1);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $7TH2w = parcelRequire("7TH2w");

var $Asv1P = parcelRequire("Asv1P");

var $lGgRw = parcelRequire("lGgRw");

var $hoiF1 = parcelRequire("hoiF1");
const $0a9efcd3d36ca5be$export$473cb05bf335b0e1 = ({ testId: testId, picture: picture, email: email, content: content, trustPicture: trustPicture = false, AccountMenuTrigger: AccountMenuTrigger })=>{
    const [isOpen, setIsOpen] = (0, $gwFzn.useState)(false);
    const close = (0, $Asv1P.useCallbackWithAnalytics)(()=>setIsOpen(false), {
        eventType: (0, $7TH2w.UI_EVENT_TYPE),
        action: 'closed',
        actionSubject: 'popup',
        actionSubjectId: 'accountMenu'
    }, (0, $hoiF1.NAVIGATION_CHANNEL));
    const open = (0, $Asv1P.useCallbackWithAnalytics)(()=>setIsOpen(true), {
        eventType: (0, $7TH2w.UI_EVENT_TYPE),
        action: 'opened',
        actionSubject: 'popup',
        actionSubjectId: 'accountMenu'
    }, (0, $hoiF1.NAVIGATION_CHANNEL));
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lGgRw.default), {
        isOpen: isOpen,
        onClose: close,
        testId: testId,
        placement: "bottom",
        trigger: (triggerProps)=>/*#__PURE__*/ (0, $7UHDa.jsx)(AccountMenuTrigger, {
                onClick: isOpen ? close : open,
                testId: testId && `${testId}--trigger`,
                picture: picture,
                email: email,
                trustPicture: trustPicture,
                ...triggerProps
            }),
        content: content
    });
};

});



parcelRegister("3yPEN", function(module, exports) {

$parcel$export(module.exports, "LoginButton", () => $bb152153185cb6ba$export$b78a3abd8101bea6);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $ilSNM = parcelRequire("ilSNM");

var $inPa6 = parcelRequire("inPa6");

var $lXg1y = parcelRequire("lXg1y");

var $dEBDF = parcelRequire("dEBDF");

var $dPJCf = parcelRequire("dPJCf");

var $jlIaF = parcelRequire("jlIaF");
const $bb152153185cb6ba$var$LOGIN_URL = typeof window !== 'undefined' ? `${0, $jlIaF.CONTEXT_PATH}/login.action?os_destination=${window.location.pathname.replace((0, $jlIaF.CONTEXT_PATH), '')}` : '';
const $bb152153185cb6ba$export$b78a3abd8101bea6 = ()=>{
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const onClick = (e)=>{
        if (e.metaKey) window.open($bb152153185cb6ba$var$LOGIN_URL, '_blank', 'noreferrer');
        else push($bb152153185cb6ba$var$LOGIN_URL);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'globalNavigation',
                action: 'clicked',
                actionSubject: 'navigationItem',
                actionSubjectId: 'login',
                attributes: {
                    selectedItemPageContext: routeDataRef.current?.routeName,
                    navigationLayer: 'global',
                    navVersion: '4',
                    navdexPointType: (0, $dEBDF.START_TOUCH)
                }
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lXg1y.UserAction), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ilSNM))),
        onClick: onClick,
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $bb152153185cb6ba$var$i18n.login)
    });
};
const $bb152153185cb6ba$var$i18n = (0, $2nPZH.defineMessages)({
    login: {
        id: "app-navigation.top-navigation.login",
        defaultMessage: "Log in"
    }
});

});

parcelRegister("eDVeb", function(module, exports) {

$parcel$export(module.exports, "SearchBar", () => $eb2a5d9806ae71d8$export$79d13b60110f33be);

var $gwFzn = parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $98yls = parcelRequire("98yls");

var $M3hWz = parcelRequire("M3hWz");

var $6mKj3 = parcelRequire("6mKj3");

var $fsMoS = parcelRequire("fsMoS");
var $hEH3o = parcelRequire("hEH3o");
var $5bPOK = parcelRequire("5bPOK");

var $jlIaF = parcelRequire("jlIaF");

var $e4o8D = parcelRequire("e4o8D");
const $eb2a5d9806ae71d8$export$79d13b60110f33be = ()=>{
    const theme = (0, $98yls.useLegacySearchTheme)();
    const [isQuickFindEnabled] = (0, $5bPOK.useQuickFindEnabled)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const renderSearchBar = ()=>{
        return renderServerPlaceholder ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $M3hWz.ProductSearchInputSkeletonInteractiveSSR), {
            placeholder: "Search",
            advancedSearchUrl: `${(0, $jlIaF.CONTEXT_PATH)}/search`,
            shouldFillContainer: true
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fsMoS.NavigationSearchDialog), {
            shouldFillContainer: true,
            theme: theme
        });
    };
    const renderQuickFind = ()=>{
        /**
		 * Note: The return value of expValEquals can be false when:
		 *  - The user is in the control group of the experiment, in this case
		 *    cohort === 'control' and an exposure is counted
		 *  - The user is not in the experiment, in this case cohort === null
		 * 	 	and an exposure is not counted
		 */ return renderServerPlaceholder && !(0, $6mKj3.expValEquals)('confluence_quick_find_ssr', 'cohort', 'test') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $M3hWz.ProductSearchInputSkeletonInteractiveSSR), {
            placeholder: "Search",
            advancedSearchUrl: `${(0, $jlIaF.CONTEXT_PATH)}/search`,
            shouldFillContainer: true
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hEH3o.QuickFindAsync), null);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: [
            $eb2a5d9806ae71d8$var$searchBarWrapper,
            isQuickFindEnabled && $eb2a5d9806ae71d8$var$flexStyles
        ]
    }, isQuickFindEnabled ? renderQuickFind() : renderSearchBar());
};
const $eb2a5d9806ae71d8$var$searchBarWrapper = (0, $ecnYn.xcss)({
    position: 'relative',
    width: '100%',
    maxWidth: '780px'
});
const $eb2a5d9806ae71d8$var$flexStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center'
});

});
parcelRegister("hEH3o", function(module, exports) {

$parcel$export(module.exports, "QuickFindAsync", () => $fdb2500e60d25720$export$96939788a99e8cd1);

var $gwFzn = parcelRequire("gwFzn");

var $kvBa6 = parcelRequire("kvBa6");

var $jmjWc = parcelRequire("jmjWc");

var $dPJCf = parcelRequire("dPJCf");

var $jlIaF = parcelRequire("jlIaF");

var $gz8ZY = parcelRequire("gz8ZY");
const $fdb2500e60d25720$export$8f0d616c2469c6b6 = ()=>{
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    const onEnter = (0, $gwFzn.useCallback)((e)=>{
        const input = e.target;
        input.blur();
        push(`${(0, $jlIaF.CONTEXT_PATH)}/search/?text=${input.value}`);
    }, [
        push
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kvBa6.QuickFindSkeleton), {
        onEnter: onEnter,
        isNav4Enabled: isNav4Enabled
    });
};

const $fdb2500e60d25720$export$96939788a99e8cd1 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "CSp8g",
    name: "QuickFindAsync",
    loader: async ()=>(await Promise.resolve((parcelRequire("4jplB")))).QuickFind,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($fdb2500e60d25720$export$8f0d616c2469c6b6, null)
});

});


parcelRegister("cAMBp", function(module, exports) {

$parcel$export(module.exports, "RovoButton", () => $a043f210edc9881e$export$268af8ca93822c63);

var $gwFzn = parcelRequire("gwFzn");

var $hFfmQ = parcelRequire("hFfmQ");

var $d9tcB = parcelRequire("d9tcB");
var $dHe7o = parcelRequire("dHe7o");

var $9wGTI = parcelRequire("9wGTI");
const $a043f210edc9881e$export$268af8ca93822c63 = ()=>{
    const { isLoggedIn: isLoggedIn, isRovoEnabled: isRovoEnabledSessionData, isRovoLLMEnabled: isRovoLLMEnabled, accessStatus: accessStatus } = (0, $dHe7o.useSessionDataWithRovoExperiment)();
    const shouldShowRovo = (0, $9wGTI.fg)('rovo_use_rovo_llm_enabled_check') ? isRovoLLMEnabled : isRovoEnabledSessionData;
    const isRovoEnabled = shouldShowRovo && isLoggedIn && accessStatus !== (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, isRovoEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hFfmQ.ConversationAssistantNavBarButton), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hFfmQ.RovoEntitlementSetter), {
        isRovoEnabled: isRovoEnabled
    }));
};

});


//# sourceMappingURL=PageLayout.f913c664.js.map
